var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89844 14.7812C5.00391 14.957 4.96875 15.168 4.82812 15.3086L4.65234 15.5195C4.47656 15.7305 4.16016 15.6953 3.98438 15.4844C3.35156 14.5703 3 13.4453 3 12.25C3 9.15625 5.49609 6.625 8.625 6.625H14.25V4.41016C14.25 3.35547 15.5156 2.86328 16.1836 3.63672L18.7148 6.44922C19.1016 6.87109 19.1016 7.53906 18.7148 7.96094L16.1836 10.7734C15.5156 11.5469 14.25 11.0547 14.25 10V7.75H8.625C6.12891 7.75 4.125 9.78906 4.125 12.25C4.125 13.1992 4.40625 14.0781 4.89844 14.7812ZM15.375 4.375V10L17.9062 7.1875L15.375 4.375ZM19.9805 9.05078C20.6133 9.96484 21 11.0898 21 12.25C21 15.3789 18.4688 17.875 15.375 17.875H9.75V20.125C9.75 21.1797 8.44922 21.6719 7.78125 20.8984L5.25 18.0859C4.86328 17.6641 4.86328 16.9961 5.25 16.5742L7.78125 13.7617C8.44922 12.9883 9.75 13.4805 9.75 14.5352V16.75H15.375C17.8359 16.75 19.875 14.7461 19.875 12.25C19.875 11.3359 19.5586 10.457 19.0664 9.75391C18.9609 9.57812 18.9961 9.36719 19.1367 9.22656L19.3125 9.01562C19.4883 8.80469 19.8047 8.83984 19.9805 9.05078ZM8.625 20.125V14.5L6.09375 17.3125L8.625 20.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.3a336cc6.svg";
export { ForwardRef as ReactComponent };